import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Data } from '@angular/router';
import {
  TabsContainerService,
  BaseTabsContainer,
  UserService,
  BaseDataService,
  ModalService,
  ModelDataService,
  ErrorHandlerService,
  NotificationService,
  TableContextMenuItem,
  QueryParameter,
  ConfirmationDialogButtons,
  ModelData,
  ModalSize
} from 'yt-ng-framework';
import { DefaultListTabsComponent } from 'yt-ng-framework';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EOtpremnicaView } from './eotpremnica-view';
import { EOtpremnicaService } from './eotpremnica-service';
import { EOtpremnicaTabUpdateComponent } from './eotpremnica-tab-update.component';
import { EOtpremniceFilterComponent } from '../_filters/eotpremnice-filter.component';
import { EOtpremnica } from './eotpremnica';
import { HttpErrorResponse } from '@angular/common/http';
import { CommentComponent } from 'src/app/lookups/_forme/comment/comment.component';
import { Attachment } from '../edokument/attachment';
import { Observable, Subject } from 'rxjs';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { translate } from '@angular/localize/src/utils';
import { take } from 'rxjs/operators';

@Component({
  selector: 'yt-eotpremnica-tabs',
  templateUrl: './eotpremnica-tabs.component.html',
  providers: [TabsContainerService],
})
export class EOtpremnicaTabsComponent
  extends BaseTabsContainer<EOtpremnicaView>
  implements OnInit {
  @ViewChild('defaultList', { static: false })
  defaultList: DefaultListTabsComponent<EOtpremnicaView>;
  @ViewChild("filterFak", { static: false }) filterFak: EOtpremniceFilterComponent;
  @Input() RefreshStatusClicked() {}
  @ViewChild('baseTabsUpdate', { static: false })
  eotpremnicaTabUpdateComponent: EOtpremnicaTabUpdateComponent;
  osvezavanjeUToku=false;
  items: Attachment[] = [];
  loading: boolean = false;

  constructor(
    public tabsContainerService: TabsContainerService<EOtpremnicaView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected toastrService: NotificationService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected errorService: ErrorHandlerService,
    protected eotpremnicaService: EOtpremnicaService,
  ) {
    super(tabsContainerService, activatedRoute, userService);
  }

  
  ngOnInit(): void {
    super.ngOnInit();

    this.eotpremnicaService.baseTabsComponent = this;

    // Osnovna inicijalizacija: hvatanje promene taba (ako želiš logiku kasnije)
    this.tabsContainerService.ActiveTab.subscribe(tabID => {
      if (tabID === 'tbList') {
        console.log('[EOtpremnicaTabsComponent] Povratak na listu');
      } else if (tabID === 'tbUpdate') {
        console.log('[EOtpremnicaTabsComponent] Otvoren tab za izmenu');
      }
    });
  }

  applayFilter(data) {
    this.defaultList.LoadMainItems(true, data);
  }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.defaultList.filterComponent = this.filterFak;
  //     this.filterFak.ApplyFilter();
  //   }, 1000);
  // }

  ngAfterViewInit() {
  
    setTimeout(() => {
      this.defaultList.filterComponent = this.filterFak;        
        this.filterFak.showStatusBox = true;
        this.filterFak.ApplyFilter();   

        // if (this.defaultList.mainItems){
          // this.filterFak.RefreshStatusClick();
          this.filterFak.StatusRefreshTime=new Date();
          this.filterFak.loadingFilter = false;
          this.loading = false;
          this.filterFak.SetStatusDescription(this.modelData["MainList"]["FormControlDataName"] == 'eotpremnice/izeotpremnica');
          this.filterFak.collapsed1=true;
          this.filterFak.filterFormGroup.enable();
        // }
        
    }, 1000);
        const intervalCheck = setInterval(() => {
        if (this.defaultList.mainItems) {
          clearInterval(intervalCheck); // Prekini proveru kada se inicijalizuje
        const brojDanaZaProveru = 5;
        this.refreshStatus(brojDanaZaProveru);
      }
    }, 100); // Provera na svakih 100ms
  }


  async refreshStatus(oldToDays: number) {
    var nastalaJeGreska=false;
    let __this=this;
    var odDana = new Date();
    let doDana = new Date();
    let proveraIDs : boolean = false;

    // const selectedItem = this.defaultList?.defaultTable?.Items?.find(item => item && item.Selected === true);
    const selectedState = this.defaultList.GetMainSelectionState();
    // const selectedItem : any= this.defaultList?.mainItems?.find(item => item.Selected);

    // const selectedItemId: number = selectedItem ? selectedItem.ID : null;

    // const selectedItemIndex: number = selectedItemId
    //   ? this.defaultList.mainItems.findIndex(item => item.ID === selectedItemId)
    //   : -1;


    this.filterFak.filterFormGroup.disable();
    this.filterFak.StatusRefreshTime=new Date();
    this.filterFak.SetStatusDescription(this.modelData["MainList"]["FormControlDataName"] == 'eotpremnice/izeotpremnica');
    this.filterFak.loadingFilter = true;
    this.loading = true;

    odDana.setDate(odDana.getDate() - oldToDays);
    odDana = new Date(odDana.getFullYear(), odDana.getMonth(), odDana.getDate());

      if (this.defaultList.mainItems != null){
        const itemsZaOsvezavanje = this.defaultList.mainItems.filter(value => {
          const d = value["Datum"];
          const jsDate = new Date(d["year"], d["month"] - 1, d["day"]); // i ovo je 00:00
          return jsDate >= odDana;   // ovde gledaš samo od tog datuma pa naviše
        });

        let eo_ids: string = "";
        for (const value of itemsZaOsvezavanje) {
          const jsDate = new Date(
            value["Datum"]["year"],
            value["Datum"]["month"] - 1,
            value["Datum"]["day"]
          );

          eo_ids += (eo_ids ? "," : "") + value.BrojUlazneOtpremnice;

          try {
            await __this.OsveziStatus(value["ID"], true);
            console.log("OsveziStatus");
          } 
          catch (error) {
            nastalaJeGreska=true;
            console.log("nastalaJeGreska"+ value["ID"].toString());
          }
       
      };

    if (nastalaJeGreska)
      // console.log("GreĹˇka pri osveĹľavanju statusa..")
      this.translateService.get('EOTPREMNICA.STATUS.NEMOZEDAOSVEZI')
      .subscribe(translate => {
        window.alert(translate);
      })
    

      if (__this.modelData["MainList"]["FormControlDataName"] == 'eotpremnice/uleotpremnica'){
        
        __this.GetNewDespatchAdviceDocuments(odDana, doDana, eo_ids)
        .subscribe((value)=>{
          proveraIDs = value;
          if(proveraIDs){
              __this.filterFak.StatusRefreshTime=new Date();
              __this.filterFak.loadingFilter = false;
              __this.loading = false,
              __this.filterFak.SetStatusDescription(false);
              __this.filterFak.collapsed1=true;
              __this.filterFak.filterFormGroup.enable();
              setTimeout(() => {
                // __this.vratiSelektovaniRed(selectedItemId, selectedItemIndex);
                __this.defaultList.RestoreMainSelection(selectedState.id, selectedState.index);
              }, 0);

            }
          })
      }

      else{
        __this.filterFak.loadingFilter = false;
        __this.loading = false;
        __this.filterFak.collapsed1=true;
        __this.filterFak.filterFormGroup.enable();
        setTimeout(() => {
          // __this.vratiSelektovaniRed(selectedItemId, selectedItemIndex);
          this.defaultList.RestoreMainSelection(selectedState.id, selectedState.index);
        }, 0);
              
      }
   
    }
  }

  // private vratiSelektovaniRed(selectedItemId: number, selectedItemIndex: number): void {
  //   if (!this.defaultList || !this.defaultList.mainItems || this.defaultList.mainItems.size === 0) {
  //     return;
  //   }

  //   let item: any = selectedItemId
  //     ? this.defaultList.mainItems.find(x => x.ID === selectedItemId)
  //     : null;

  //   if (!item && selectedItemIndex >= 0 && selectedItemIndex < this.defaultList.mainItems.size) {
  //     item = this.defaultList.mainItems.get(selectedItemIndex);
  //   }

  //   if (!item) {
  //     item = this.defaultList.mainItems.get(0);
  //   }

  //   if (!item) {
  //     return;
  //   }

  //   this.defaultList.SelectMainItem(item);

  //   if (this.defaultList.defaultTable) {
  //     this.defaultList.defaultTable.SetSelectedItem = item;
  //     this.defaultList.defaultTable.ScrollToView = true;
  //   }
  // }

  // private updateMainItemBezSelekcije(updatedItem: any): void {
  //   if (!updatedItem || !this.defaultList || !this.defaultList.mainItems) {
  //     return;
  //   }

  //   const index = this.defaultList.mainItems.findIndex(item => item.ID === updatedItem.ID);

  //   if (index < 0) {
  //     return;
  //   }

  //   const oldItem: any = this.defaultList.mainItems.get(index);

  //   updatedItem.Selected = oldItem ? oldItem.Selected === true : false;
  //   updatedItem.Checked = oldItem ? oldItem.Checked : false;

  //   this.defaultList.mainItems = this.defaultList.mainItems.set(index, updatedItem);

  //   if (this.defaultList.defaultTable) {
  //     this.defaultList.defaultTable.SetSelectedItem =
  //       this.defaultList.mainItems.find(item => item.Selected === true);
  //   }
  // }

  GetNewDespatchAdviceDocuments(odDana: Date, doDana : Date, eo_ids: string): Observable<boolean>{
    this.osvezavanjeUToku=true;
    var subject = new Subject<boolean>();
    let odDana1: NgbDate = new NgbDate(odDana.getFullYear(), odDana.getMonth() + 1, odDana.getDate());
    let doDana1: NgbDate = new NgbDate(doDana.getFullYear(), doDana.getMonth() + 1, doDana.getDate());


    this.baseDataService
      .Post("EOtpremnica", "GetUlazneOtpremnice", {'DateFrom' : odDana1, 'DateTo' : doDana1, 'EoIds' : eo_ids}, EOtpremnicaView)
      .subscribe((data: EOtpremnicaView[]) => {
          let brojNovihUlaznih : Number = data.length;
          let brojNovihKomitenata: number = data.filter(item => item.NoviKomitent == true).length;

          if (data != null){
            // data.forEach(item => 
            //   this.tabsContainerService.EmitItem(item)
            // );    
            data.forEach(item => 
              this.defaultList.AddOrUpdateMainItemWithoutSelectionChange(item)
            );              
            this.osvezavanjeUToku=false;
          }   
          this.translateService.get(['EOTPREMNICA.BROJNOVIHULAZNIH.TITLE', 'EOTPREMNICA.BROJNOVIHKOMITENATA.TITLE']) 
          .subscribe(translate => {         
            this.toastrService.info(translate['EOTPREMNICA.BROJNOVIHULAZNIH.TITLE'],
              brojNovihUlaznih.toString());
            if (brojNovihKomitenata>0)             
              this.modalService.ShowConfirmationDialog("Novi komitenti",translate['EOTPREMNICA.BROJNOVIHKOMITENATA.TITLE']+": "+brojNovihKomitenata.toString(),"info", ConfirmationDialogButtons.Ok)
            subject.next(true);    
          })
      }
      , error => {
      this.filterFak.loadingFilter = false;
      this.loading = false;
      let _message;   
      if(error instanceof HttpErrorResponse){
        _message = this.errorService.getServerMessage(error);           
        _message = "FW.ERRORS." + _message;
        this.translateService.get(_message)
        .subscribe(translate => {
          this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja ulaznih otpremnica", translate, "warning", ConfirmationDialogButtons.Ok);
        });
      }
  })
    return subject.asObservable();
  }

  // private addOrUpdateMainItemBezSelekcije(item: any): void {
  //   if (!item || !this.defaultList) {
  //     return;
  //   }

  //   if (!this.defaultList.mainItems) {
  //     return;
  //   }

  //   const index = this.defaultList.mainItems.findIndex(x => x.ID === item.ID);

  //   if (index >= 0) {
  //     const oldItem: any = this.defaultList.mainItems.get(index);

  //     item.Selected = oldItem ? oldItem.Selected === true : false;
  //     item.Checked = oldItem ? oldItem.Checked : false;

  //     this.defaultList.mainItems = this.defaultList.mainItems.set(index, item);
  //   } else {
  //     item.Selected = false;
  //     item.Checked = false;

  //     this.defaultList.mainItems = this.defaultList.mainItems.push(item);
  //   }
  // }

  getProvajderGenericName(id: number) {
    var parameters = [];
    var provajderId = new QueryParameter();
    provajderId.Name = "id";
    provajderId.Value = id;
    parameters.push(provajderId);
    return this.baseDataService.Get(
      "Provajder",
      "getGenericName",
      parameters,
      null
    );
  }

  Ponovi(id) {
    let userRightsModelName = this.modelData.MainList.UserRightsModelName;
    let date = new Date();
    let idParameter = new QueryParameter("ID", id);
    let datumDokumentaParameter = new QueryParameter (
            "datumDok",
             new NgbDate(date.getFullYear(), date.getMonth()+1,date.getDate())
          );
    this.baseDataService
      .Post("EOtpremnica", "GetKopija", {"ID":id, "datumDok":new NgbDate(date.getFullYear(), date.getMonth()+1,date.getDate())}, EOtpremnicaView)
      .subscribe((data: EOtpremnicaView[]) =>
      {
        if (data != null) this.tabsContainerService.EmitItem(data[0]);
      }
      , error => {
        if (error instanceof HttpErrorResponse) {
          let _message;
          _message = this.errorService.getServerMessage(error);

          this.translateService.get(["EOTPREMNICA.GETKOPIJA.ERROR",_message])
          .subscribe(translate => {
            this.modalService.ShowConfirmationDialog(translate["EOTPREMNICA.GETKOPIJA.ERROR"], translate[_message], "warning", ConfirmationDialogButtons.Ok);
          })
        }
      }
      )
  }

PosaljiEOtpremnicu(id: number){
  let _id: Number = id;
  
      this.baseDataService
        .GetByID("EOtpremnica", id, EOtpremnica)
        .subscribe((item: EOtpremnica) => {
          let _masterDokumID: Number = item.MasterDokumID;
          let _statusID = item.StatusID;
          let _today: Date = new Date();
          let _datum: Date = new Date(
            item.Datum["year"],
            item.Datum["month"] - 1,
            item.Datum["day"]
          );

          if (
            new Date(_datum.toLocaleDateString()) <
            new Date(_today.toLocaleDateString())
          ) {
            this.translateService
              .get(["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"])
              .subscribe((translate) => {
                this.toastrService.warning(
                  translate["EDOKUMENT.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]
                );
              });
            return false;
          }
        
            var /** @type {?} */ parameters1 = [];
            var /** @type {?} */ parameter = new QueryParameter();
            parameter.Name = "statusID";
            parameter.Value = _statusID;
            parameters1.push(parameter);

            if (_statusID == null){
              let _modelData =
                      this.modelDataService.GetModelDataByPath("send-eotpremnica");
                      let idParameter = new QueryParameter("eOtpremnicaID", _id);
                      let masterIdParameter = new QueryParameter(
                        "masterDokumID",
                        _masterDokumID
                      );
                      
                      let formControlDataNameParameter = new QueryParameter("formControlDataName", this.modelData["MainList"]["FormControlDataName"]);

                      if (_modelData) {
                        this.modalService
                          .ShowModal(0, _modelData, null, true, [
                            idParameter,
                            masterIdParameter,
                            formControlDataNameParameter
                          ])
                          .result.then(
                            (item) => {
                              this.defaultList.mainItems.find(
                                (x) => x.ID === id
                              ).OsvezivogStatusa = true;
                              this.OsveziStatus(id, false);
                            },
                            (reason) => {}
                          );
                      }
            }

            
          });
}


PocetakVoznje(id){ 
  this.eotpremnicaService.PocetakVoznjeService(id);
}

StornoDokument(id){ 
  this.eotpremnicaService.StornoService(id);
  }

prevod;

  async OsveziStatus(id, silent){
  if (this.defaultList.mainItems.find((x) => x.ID === id).OsvezivogStatusa)
  {
    let idParameter = new QueryParameter("id",id);
    let vrsta = this.modelData["MainList"]["UserRightsModelName"];
    let vrstaParameter = new QueryParameter("vrsta", vrsta);

    // this.baseDataService 
    //     .Get("EOtpremnica","OsveziStatus",[idParameter, vrstaParameter], EOtpremnicaView)
    //     .subscribe((data: EOtpremnicaView[]) =>{
    //       if (data != null) this.tabsContainerService.EmitItem(data[0]);
    //     });
    
      const refreshedItem: any = await this.baseDataService 
        .Get("EOtpremnica","OsveziStatus",[idParameter, vrstaParameter], EOtpremnicaView)
        .toPromise();
      
      // this.tabsContainerService.EmitItem(refreshedItem[0]);
      if (refreshedItem && refreshedItem.length > 0) {
        if (silent) {
          // this.updateMainItemBezSelekcije(refreshedItem[0]);
          this.defaultList.UpdateMainItemWithoutSelectionChange(refreshedItem[0]);
        } else {
          this.tabsContainerService.EmitItem(refreshedItem[0]);
        }
      }
      

  }
  else {
    if (!silent){
      this.translateService
      .get("EOTPREMNICA.STATUS.NEMOZEDAOSVEZI")
      .subscribe((translate) => {
        this.prevod = translate

        this.modalService.ShowConfirmationDialog(
          "Obaveštenje",
          this.prevod,
          "alert",
          ConfirmationDialogButtons.Ok
        );
      });
    }
  }
}

FizickiPrijem(id){
  this.eotpremnicaService.FizickiPrijemService(id);
  
}

KreirajPrijemnicu(id){
  this.eotpremnicaService.KreirajPrijemnicuService(id);
}

// PrihvatiPrijemnicu(id){
//   this.eotpremnicaService.PrihvatiPrijemnicuService(id);
// }

// OdbijPrijemnicu(id){
//   this.eotpremnicaService.OdbijPrijemnicuService(id);
// }

PromenaVozila(id){
  this.eotpremnicaService.PromenaVozilaService(id);
  
}

ContextMenuClicked(contextMenuItem : TableContextMenuItem){
  if (contextMenuItem.Action == "Ponovi") {
    let id: number = contextMenuItem.ID;
    this.Ponovi(id);
  }
  if (contextMenuItem.Action == "PosaljiEOtpremnicu") {
    let id: number = contextMenuItem.ID;
    this.PosaljiEOtpremnicu(id);
  }
  if (contextMenuItem.Action == "PocetakVoznje") {
    let id: number = contextMenuItem.ID;
    this.PocetakVoznje(id);
  }
  if (contextMenuItem.Action == "StornoDokument") {
    let id: number = contextMenuItem.ID;
    this.StornoDokument(id);
  }
  if (contextMenuItem.Action == "OsveziStatus") {
    let id: number = contextMenuItem.ID;
    this.OsveziStatus(id, false);
  }
  if (contextMenuItem.Action == "FizickiPrijem"){
    let id:number = contextMenuItem.ID;
    this.FizickiPrijem(id);
  }
  if (contextMenuItem.Action == "KreirajPrijemnicu"){
    let id:number = contextMenuItem.ID;
    this.KreirajPrijemnicu(id);
  }
  // if (contextMenuItem.Action == "PrihvatiPrijemnicu"){
  //   let id:number = contextMenuItem.ID;
  //   this.PrihvatiPrijemnicu(id);
  // }
  //  if (contextMenuItem.Action == "OdbijPrijemnicu"){
  //   let id:number = contextMenuItem.ID;
  //   this.OdbijPrijemnicu(id);
  // }
  if (contextMenuItem.Action == "PromenaVozila"){
    let id:number = contextMenuItem.ID;
    this.PromenaVozila(id);
  }
}

  SelectItemFormatDetailClicked(item) {
    // let brojDecimala = item.BrojDecimala;
    // let formatString = "1." + brojDecimala + "-" + brojDecimala;
    // if (this.defaultList["detailTable"].TableColumns[3].Format != formatString) {
    //   this.defaultList["detailTable"].TableColumns[3].Format = formatString;
    // }

    // });
  }



}
